import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Row, Col, Button } from 'react-bootstrap';
import InputField from '../../../../reusable-components/InputField';
import { required } from '../../../../utils/validations';
import Header from '../../../../reusable-components/Header';
import Footer from '../../../../reusable-components/Footer';
import Body from '../../../../reusable-components/Body';
import Spinner from '../../../../reusable-components/Spinner';
import PageContent from '../../../../reusable-components/ActivatePageContent';
import PageHeader from '../../../../reusable-components/ActivatePageHeader';
import PropTypes from 'prop-types';

class LoginForm extends Component {
  constructor(props){
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(values){
    const { vignet_number, pin } = values;
    this.props.loginUser(vignet_number, pin);
  }

  componentDidMount() {
    // clear localstorage
    localStorage.removeItem('access_token'); 
    localStorage.removeItem('object'); 
    localStorage.removeItem('object_id');
    localStorage.removeItem('user_id');
    localStorage.removeItem('chip_id');
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.user !== prevProps.user) {
      this.props.history.push('/activate/step/two');
    }
  }

  render() {
    const { 
      handleSubmit, 
      pristine, 
      submitting, 
      isloading, 
      error,
      error_message,
      initialValues } = this.props;

    let buttonState = null;

    buttonState = isloading ? <Spinner /> : "Doorgaan";

    return (
      <>
        <PageHeader title="Vignet informatie" />
        <PageContent 
          title="Vul aub de vignet informatie volledig in"
          goBack={() => {}}
          moveNext={() => {}}
          cardClass="card-container"
          customButtonContainerClass="align-btn-left"
          showFooter={true}
          hasSubmitBtn={true}
          formClassNames=""
          errors={error_message}
          buttonState={isloading}
          submitting={submitting}
          btnDisabled={pristine || submitting}
          handleSubmit={handleSubmit(this.onSubmit)}>
        <div className="form-container custom-container">
          <Row>
            <Col sm={12} md={6}>
              <p>Vul hier uw nieuw vignetnummer en activatiepin in. Het vignetnummer is te vinden op het nieuwe fysieke vignet.</p>
            </Col>
            <Col sm={12} md={6}>
              <div className="form-row">
                <div className="form-group col-md-12">
                  <Field
                    required
                    type="text"
                    name="vignet_number"
                    label="Vignet nummer"
                    component={InputField}
                    validate={required}
                  />
                </div>
                <div className="form-group col-md-12">
                  <Field
                    required
                    type="password"
                    name="pin"
                    label="PIN"
                    component={InputField}
                    validate={required}
                  />
                </div>
              </div>
            </Col>
            {/*<div className="content-footer">
              <button type="submit" className="btn continue-btn mobile-continue-btn" disabled={pristine || submitting}>
                {buttonState}
              </button>
            </div>*/}
          </Row>
        </div>
        </PageContent>
      </>
    );
  }
}

LoginForm.propTypes = {
  isloading: PropTypes.bool,
  error_message: PropTypes.string,
  formErrors: PropTypes.object,
  initialValues: PropTypes.object,
}

const LoginComponent = reduxForm({
  form: 'step-one'
})(LoginForm);

export default LoginComponent;

